import { IFlow } from '../interfaces/Flow';
import { LOAD_REVISIT_FLOW } from './actions';

export const loadRevisitFlow = (payload: IFlow) => ({
  type: LOAD_REVISIT_FLOW,
  payload
});